export const mapToQueryString = (value?: null | unknown | unknown[]): string => {
  return value === undefined || value === null ? '' : value.toString()
}
